"use client";

import { HmcTabPanel } from "@adi-ctx/harmonic-core-components-react";

/**
 * Override the original Harmonic Tab Panel component
 * so that it can be used in server components as well
 * @constructor
 */
export default function TabPanel({ children, ...props }: Record<string, any>) {
	return (
		<HmcTabPanel
			data-testid="tab-panel"
			slot="panel"
			name={props.name}
			{...props}
			className={`mt-6 ${props.className || ""}`}
		>
			{children}
		</HmcTabPanel>
	);
}
